import { get } from 'lodash';
import uPlot from 'uplot';

type OptionsUpdateState = 'keep' | 'update' | 'create';

export const optionsUpdateState = (
  _lhs: uPlot.Options,
  _rhs: uPlot.Options,
): OptionsUpdateState => {
  const { width: lhsWidth, height: lhsHeight, ...lhs } = _lhs;
  const { width: rhsWidth, height: rhsHeight, ...rhs } = _rhs;

  let state: OptionsUpdateState = 'keep';
  if (lhsHeight !== rhsHeight || lhsWidth !== rhsWidth) {
    state = 'update';
  }
  if (Object.keys(lhs).length !== Object.keys(rhs).length) {
    return 'create';
  }
  for (const k of Object.keys(lhs)) {
    if (!Object.is(get(lhs, k), get(rhs, k))) {
      state = 'create';
      break;
    }
  }
  return state;
};

export const chartDataMatches = (
  lhs: uPlot.AlignedData,
  rhs: uPlot.AlignedData,
): boolean => {
  if (lhs.length !== rhs.length) {
    return false;
  }
  return lhs.every((lhsOneSeries, seriesIdx) => {
    const rhsOneSeries = rhs[seriesIdx];
    if (lhsOneSeries.length !== rhsOneSeries.length) {
      return false;
    }

    if (Array.isArray(lhsOneSeries)) {
      return lhsOneSeries.every(
        (value, valueIdx) => value === rhsOneSeries[valueIdx],
      );
    }
    return false;
  });
};
